import React, { useState, useEffect } from 'react'
import api from "../../api/axios";

const PricePerMinute = () => {
  const [selectedChain, setSelectedChain] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [chains, setChains] = useState([]);
  const [error, setError] = useState(null);
  
  // System constants
  const [systemConstant, setSystemConstant] = useState({
    Nombre_d_heures_par_jour: "",
    Taux_horaire_SMIG_16_29: "",
    Taux_horaire_17_00: "",
    Taux_horaire_17_50: "",
    Masse_salariale_16_29: "",
    Masse_salariale_17_00: "",
    Masse_salariale_17_50: "",
    Capacité_par_unité_transport: "",
    cotisation_entroprise_trans: "",
    Coût_par_trajet: "",
    Coût_énergie_journalier: "",
    Coût_charges_fixes_journalier: "",
  });
  
  // Day-by-day data
  const [workedHoursByDate, setWorkedHoursByDate] = useState({});
  const [effectiveDataByDate, setEffectiveDataByDate] = useState({});
  const [effectiveIndirectDataByDate, setEffectiveIndirectDataByDate] = useState({});
  const [cle, setCle] = useState(0);
  const [filsParChain, setFilsParChain] = useState(0);
  
  // Total values
  const [totalCoûtDeRevient, setTotalCoûtDeRevient] = useState(0);
  const [productionChainValeur, setProductionChainValeur] = useState(0);
  const [margeNette, setMargeNette] = useState(0);
  const [IS, setIS] = useState(0);
  const [valeurDeTravail, setValeurDeTravail] = useState(0);
  const [averageEffectifDirect, setAverageEffectifDirect] = useState(0);
  const [totalWorkedMinutes, setTotalWorkedMinutes] = useState(0);
  const [minuteProduit, setMinuteProduit] = useState(0);
  const [minutePresance, setMinutePresance] = useState(0);
  const [rendement, setRendement] = useState(0);
  const [couteMinute, setCouteMinute] = useState(0);


  // Fetch chains
  const fetchChains = async () => {
    try {
      const response = await api.get('/chains');
      setChains(response.data);
    } catch (error) {
      console.error('Error fetching chains:', error);
      setError('Error fetching chains');
    }
  };

  // Fetch cle
  const fetchCle = async (chainId) => {
    try {
      const response = await api.get(`/product_plans_cle/${chainId}`);
      setCle(response.data.cle);
    } catch (error) {
      console.error("Error fetching cle:", error);
    }
  };

  // Fetch worked hours by date
  const fetchWorkedHours = async (chainId) => {
    try {
      const modelResponse = await api.get(`/getmodelsByChain/${chainId}`);
      const modelId = modelResponse.data.id;
      setSelectedModel(modelId);
      
      const response = await api.get(`/production_real_hours/${modelId}/${chainId}`);
      setWorkedHoursByDate(response.data.worked_hours_by_date || {});
    } catch (error) {
      console.error("Error fetching worked hours:", error);
      setError(error.response?.data?.message || "An error occurred");
    }
  };

  // Fetch effective direct data by date
  const fetchEffectiveDataByDate = async (chainId) => {
    try {
      const modelResponse = await api.get(`/getmodelsByChain/${chainId}`);
      const modelId = modelResponse.data.id;
      
      const response = await api.get(`/effective_real_total/${modelId}/${chainId}`);
      setEffectiveDataByDate(response.data);
      } catch (error) {
      console.error("Error fetching effective direct data:", error);
    }
  };

  // Fetch effective indirect data by date
  const fetchEffectiveIndirectDataByDate = async (chainId) => {
    try {
      const modelResponse = await api.get(`/getmodelsByChain/${chainId}`);
      const modelId = modelResponse.data.id;
      
      const response = await api.get(`/effective_indirect_by_model_chain_day/${modelId}/${chainId}`);
      setEffectiveIndirectDataByDate(response.data);
    } catch (error) {
      console.error("Error fetching effective indirect data:", error);
    }
  };

  // Fetch temp alloue (valeur de travail)
  const fetchTempAlloue = async (modelId) => {
    try {
      const response = await api.get(`/temps-alloue/${modelId}`);
      const tempAlloue = response.data.temps_alloue.temps_alloue;
      setValeurDeTravail(tempAlloue);
      console.log('tempAlloue (valeur de travail):', tempAlloue);
      } catch (error) {
      console.error("Error fetching temp alloue:", error);
    }
  };

  // Calculate average effective direct for worked dates
  const calculateAverageEffectifDirect = () => {
    let totalEffectifDirect = 0;
    let workedDaysCount = 0;

    Object.keys(workedHoursByDate).forEach(date => {
      const workedHours = workedHoursByDate[date] || 0;
      const directData = effectiveDataByDate[date];

      if (workedHours > 0 && directData && directData.effectifDirects) {
        totalEffectifDirect += directData.effectifDirects;
        workedDaysCount++;
      }
    });

    const average = workedDaysCount > 0 ? totalEffectifDirect / workedDaysCount : 0;
    setAverageEffectifDirect(average);
    
    console.log('Average Effectif Direct Calculation:');
    console.log('  - Total Effectif Direct:', totalEffectifDirect);
    console.log('  - Worked Days Count:', workedDaysCount);
    console.log('  - Average:', average);
  };

  // Helper function to calculate average effectif direct value (returns value, doesn't set state)
  const calculateAverageEffectifDirectValue = () => {
    let totalEffectifDirect = 0;
    let workedDaysCount = 0;

    Object.keys(workedHoursByDate).forEach(date => {
      const workedHours = workedHoursByDate[date] || 0;
      const directData = effectiveDataByDate[date];

      if (workedHours > 0 && directData && directData.effectifDirects) {
        totalEffectifDirect += directData.effectifDirects;
        workedDaysCount++;
      }
    });

    return workedDaysCount > 0 ? totalEffectifDirect / workedDaysCount : 0;
  };

  // Calculate total worked minutes
  const calculateTotalWorkedMinutes = () => {
    const totalWorkedHours = Object.values(workedHoursByDate).reduce((sum, hours) => sum + hours, 0);
    const totalMinutes = totalWorkedHours * 60;
    setTotalWorkedMinutes(totalMinutes);
    
    console.log('Total Worked Minutes Calculation:');
    console.log('  - Total Worked Hours:', totalWorkedHours);
    console.log('  - Total Worked Minutes (hours * 60):', totalMinutes);
  };

  // Calculate minute produit = chain quantity total * valeur de travail
  const calculateMinuteProduit = async (modelId, chainId) => {
    try {
      const response = await api.get(`/chain_production_data/${modelId}`, {
        params: { chain: chainId },
      });
      const chainQuantityTotal = response.data[chainId].latestSortie || 0;
      const minuteProduitValue = chainQuantityTotal * valeurDeTravail;
      setMinuteProduit(minuteProduitValue);
      
      console.log('Minute Produit Calculation:');
      console.log('  - Chain Quantity Total (latestSortie):', chainQuantityTotal);
      console.log('  - Valeur de Travail:', valeurDeTravail);
      console.log('  - Minute Produit (quantity * valeur):', minuteProduitValue);
    } catch (error) {
      console.error("Error calculating minute produit:", error);
      setMinuteProduit(0);
    }
  };

  // Helper function to calculate minute produit value (returns value, doesn't set state)
  const calculateMinuteProduitValue = async (modelId, chainId) => {
    try {
      const response = await api.get(`/chain_production_data/${modelId}`, {
        params: { chain: chainId },
      });
      const chainQuantityTotal = response.data[chainId].latestSortie || 0;
      return chainQuantityTotal * valeurDeTravail;
    } catch (error) {
      console.error("Error calculating minute produit value:", error);
      return 0;
    }
  };

  // Calculate minute presance = Total Heures Travaillées * Moyenne Effectif Direct
  const calculateMinutePresance = () => {
    const minutePresanceValue = totalWorkedMinutes * averageEffectifDirect;
    
    setMinutePresance(minutePresanceValue);
    
    console.log('Minute Presance Calculation:');
    console.log('  - Total Worked Minutes:', totalWorkedMinutes);
    console.log('  - Average Effectif Direct:', averageEffectifDirect);
    console.log('  - Minute Presance (minutes * average effectif):', minutePresanceValue);
  };

  // Calculate rendement = minute produit / minute presance
  const calculateRendement = () => {
    const rendementValue = minutePresance > 0 ? minuteProduit / minutePresance : 0;
    setRendement(rendementValue);
    
    console.log('Rendement Calculation:');
    console.log('  - Minute Produit:', minuteProduit);
    console.log('  - Minute Presance:', minutePresance);
    console.log('  - Rendement (produit / presance):', rendementValue);
  };

  // Fetch chain data for fils calculation and production value
  const fetchChainData = async (modelId, chainId) => {
    try {
      const response = await api.get(`/chain_production_data/${modelId}`, {
        params: { chain: chainId },
      });
      
      const totalExport = response.data[chainId].latestSortie || 0;
      
      // Calculate fils cost using the same formula as MargeNetteChainChart
      const baseReference = Number(systemConstant.Base_reference_matiere_fil) || 20000;
      const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 0;
      const filCost = totalExport * (filUnitCost / baseReference);
      setFilsParChain(filCost);
      
      // Get model data for production value calculation
      const modelsResponse = await api.get("/models");
      const modelData = modelsResponse.data.find((model) => {
        return model.id == modelId;
      });
      
      if (modelData) {
        const productionChainValeur = (
          modelData.prixMOver *
          (modelData.prixFacture /
            (modelData.prixMOver * modelData.qte_societe)) *
          (response.data[chainId].latestSortie || 0)
        ).toFixed(2);
        
        console.log('productionChainValeur', productionChainValeur);
        console.log('modelData', modelData);
        console.log('response.data.totalSortie', response.data.totalSortie);
        
        setProductionChainValeur(productionChainValeur);
      }
    } catch (error) {
      console.error("Error fetching chain data:", error);
    }
  };

  // Helper functions to calculate day-by-day effectif values (matching MargeNetteChainChart)
  const calculateDayByDayEffectifDirects = (effectiveData, workedHoursData) => {
    let total = 0;
    
    Object.keys(effectiveData).forEach(date => {
      const dayData = effectiveData[date];
      const workedHours = workedHoursData[date] || 0;
      
      if (dayData && dayData.effectifDirects) {
        const dayCalculation = dayData.effectifDirects * workedHours;
        total += dayCalculation;
      }
    });
    
    return total;
  };

  const calculateDayByDayEffectifIndirects = (effectiveIndirectData, workedHoursData) => {
    let total = 0;
    
    Object.keys(effectiveIndirectData).forEach(date => {
      const dayData = effectiveIndirectData[date];
      const workedHours = workedHoursData[date] || 0;
      
      if (dayData && dayData.effectifIndirects) {
        let dayCalculation = dayData.effectifIndirects * cle;
        dayCalculation = dayCalculation * workedHours;
        total += dayCalculation;
      }
    });
    
    return total;
  };

  // Calculate day-by-day coût de revient
  const calculateDayByDayCoûtDeRevient = async () => {
    console.log("🔍 === PRICE PER MINUTE CALCULATION DEBUG ===");
    console.log("📊 System Constants:", systemConstant);
    console.log("📊 Worked Hours By Date:", workedHoursByDate);
    console.log("📊 Effective Data By Date:", effectiveDataByDate);
    console.log("📊 Effective Indirect Data By Date:", effectiveIndirectDataByDate);
    console.log("📊 Cle:", cle);
    console.log("📊 Fils Par Chain:", filsParChain);
    
    const {
      Nombre_d_heures_par_jour,
      Capacité_par_unité_transport,
      Coût_par_trajet,
      cotisation_entroprise_trans,
      Coût_énergie_journalier,
      Coût_charges_fixes_journalier,
      Taux_horaire_SMIG_16_29,
      Taux_horaire_17_00,
      Taux_horaire_17_50,
      Masse_salariale_16_29,
      Masse_salariale_17_00,
      Masse_salariale_17_50,
    } = systemConstant;

    // First calculate the total day-by-day effectif values (like MargeNetteChainChart does)
    const totalEffectifDirects = calculateDayByDayEffectifDirects(effectiveDataByDate, workedHoursByDate);
    const totalEffectifIndirects = calculateDayByDayEffectifIndirects(effectiveIndirectDataByDate, workedHoursByDate);
    
    console.log("🧮 Day-by-Day Effectif Calculations:");
    console.log("  - totalEffectifDirects:", totalEffectifDirects);
    console.log("  - totalEffectifIndirects:", totalEffectifIndirects);

    // Calculate total mass salary using the day-by-day totals (like MargeNetteChainChart)
    // Note: totalEffectifDirects and totalEffectifIndirects already include worked hours multiplication
    const congeAnual = (totalEffectifDirects * Taux_horaire_SMIG_16_29 * 1.5) / 26;
    const masseSalariale1629 = totalEffectifDirects * Masse_salariale_16_29 * 0.01 * Taux_horaire_SMIG_16_29;
    const masseSalariale1700 = totalEffectifDirects * Masse_salariale_17_00 * 0.01 * Taux_horaire_17_00;
    const masseSalariale1750 = totalEffectifDirects * Masse_salariale_17_50 * 0.01 * Taux_horaire_17_50;

    const QP_effectif = totalEffectifIndirects;
    const congeAnualIndirect = (QP_effectif * Taux_horaire_SMIG_16_29 * 1.5) / 26;
    const masseSalarialeIndirect1629 = QP_effectif * Masse_salariale_16_29 * 0.01 * Taux_horaire_SMIG_16_29;
    const masseSalarialeIndirect1700 = QP_effectif * Masse_salariale_17_00 * 0.01 * Taux_horaire_17_00;
    const masseSalarialeIndirect1750 = QP_effectif * Masse_salariale_17_50 * 0.01 * Taux_horaire_17_50;

    const masseSalarialeDirecte = masseSalariale1629 + masseSalariale1700 + masseSalariale1750 + congeAnual;
    const masseSalarialeInDirecte = masseSalarialeIndirect1700 + masseSalarialeIndirect1629 + masseSalarialeIndirect1750 + congeAnualIndirect;
    const totalMassSalary = masseSalarialeInDirecte + masseSalarialeDirecte;
    
    console.log("💸 Mass Salary Calculations:");
    console.log("  - congeAnual:", congeAnual);
    console.log("  - masseSalariale1629:", masseSalariale1629);
    console.log("  - masseSalariale1700:", masseSalariale1700);
    console.log("  - masseSalariale1750:", masseSalariale1750);
    console.log("  - masseSalarialeDirecte:", masseSalarialeDirecte);
    console.log("  - QP_effectif:", QP_effectif);
    console.log("  - congeAnualIndirect:", congeAnualIndirect);
    console.log("  - masseSalarialeIndirect1629:", masseSalarialeIndirect1629);
    console.log("  - masseSalarialeIndirect1700:", masseSalarialeIndirect1700);
    console.log("  - masseSalarialeIndirect1750:", masseSalarialeIndirect1750);
    console.log("  - masseSalarialeInDirecte:", masseSalarialeInDirecte);
    console.log("  - totalMassSalary:", totalMassSalary);

    // Calculate total transport cost (day-by-day)
    let totalTransportCost = 0;
    console.log("🚚 Transport Cost Calculations (Day-by-Day):");
    Object.keys(workedHoursByDate).forEach(date => {
      const workedHours = workedHoursByDate[date] || 0;
      const directData = effectiveDataByDate[date];
      const indirectData = effectiveIndirectDataByDate[date];

      if (workedHours > 0 && (directData || indirectData)) {
        const effectifDirectDay = directData ? directData.effectifDirects : 0;
        const effectifIndirectDay = indirectData ? indirectData.effectifIndirects : 0;
        const QP_effectif = effectifIndirectDay * cle;
        const Nombre_de_jours_de_production = 1;

        const Refacturation_transport_MOD_indirecte = -(
          (cotisation_entroprise_trans * Nombre_de_jours_de_production * QP_effectif) / 26
        );
        const Refacturation_transport_MOD_directe = -(
          (cotisation_entroprise_trans * Nombre_de_jours_de_production * effectifDirectDay) / 26
        );
        const Nombre_unite_utilise = (QP_effectif + effectifDirectDay) / Capacité_par_unité_transport;
        const dailyTransportCost = 2 * Nombre_unite_utilise * Nombre_de_jours_de_production * Coût_par_trajet +
          (Refacturation_transport_MOD_directe + Refacturation_transport_MOD_indirecte);

        totalTransportCost += dailyTransportCost;

        console.log(`  📅 ${date}:`, {
          workedHours,
          effectifDirectDay,
          effectifIndirectDay,
          QP_effectif,
          Refacturation_transport_MOD_indirecte,
          Refacturation_transport_MOD_directe,
          Nombre_unite_utilise,
          dailyTransportCost,
          runningTotal: totalTransportCost
        });
      }
    });
    console.log("  - totalTransportCost:", totalTransportCost);

    // Calculate total energy cost (day-by-day)
    let totalEnergyCost = 0;
    console.log("⚡ Energy Cost Calculations (Day-by-Day):");
    Object.keys(workedHoursByDate).forEach(date => {
      const workedHours = workedHoursByDate[date] || 0;
      if (workedHours > 0) {
        const Nombre_de_jours_de_production = workedHours / Nombre_d_heures_par_jour;
        const dailyEnergyCost = Nombre_de_jours_de_production * Coût_énergie_journalier * cle;
        totalEnergyCost += dailyEnergyCost;

        console.log(`  📅 ${date}:`, {
          workedHours,
          Nombre_de_jours_de_production,
          Coût_énergie_journalier,
          cle,
          dailyEnergyCost,
          runningTotal: totalEnergyCost
        });
      }
    });
    console.log("  - totalEnergyCost:", totalEnergyCost);

    // Calculate total charges fixes cost (day-by-day)
    let totalChargesFixesCost = 0;
    console.log("🏢 Charges Fixes Cost Calculations (Day-by-Day):");
    Object.keys(workedHoursByDate).forEach(date => {
      const workedHours = workedHoursByDate[date] || 0;
      if (workedHours > 0) {
        const Nombre_de_jours_de_production = workedHours / Nombre_d_heures_par_jour;
        const dailyChargesFixesCost = Nombre_de_jours_de_production * Coût_charges_fixes_journalier * cle;
        totalChargesFixesCost += dailyChargesFixesCost;

        console.log(`  📅 ${date}:`, {
          workedHours,
          Nombre_de_jours_de_production,
          Coût_charges_fixes_journalier,
          cle,
          dailyChargesFixesCost,
          runningTotal: totalChargesFixesCost
        });
      }
    });
    console.log("  - totalChargesFixesCost:", totalChargesFixesCost);

    // Calculate total coût de revient
    const totalCoûtDeRevient = totalMassSalary + totalTransportCost + totalEnergyCost + totalChargesFixesCost + filsParChain;
    
    console.log("📦 Final Coût de Revient Calculation:");
    console.log("  - totalMassSalary:", totalMassSalary);
    console.log("  - totalTransportCost:", totalTransportCost);
    console.log("  - totalEnergyCost:", totalEnergyCost);
    console.log("  - totalChargesFixesCost:", totalChargesFixesCost);
    console.log("  - filsParChain:", filsParChain);
    console.log("  - totalCoûtDeRevient:", totalCoûtDeRevient);
    
    // Calculate marge nette and IS
    const margeNette = parseFloat(productionChainValeur) - totalCoûtDeRevient;
    const IS = margeNette > 0 ? margeNette * 0.02 : 0;
    
    console.log("💰 Marge Nette and IS Calculation:");
    console.log("  - productionChainValeur:", productionChainValeur);
    console.log("  - totalCoûtDeRevient:", totalCoûtDeRevient);
    console.log("  - margeNette:", margeNette);
    console.log("  - IS (2% of marge nette):", IS);
    
    // Calculate average effective direct and total worked minutes
    calculateAverageEffectifDirect();
    calculateTotalWorkedMinutes();
    
    // Calculate minute produit
    await calculateMinuteProduit(selectedModel, selectedChain);
    
    // Calculate minute presance and rendement with current values
    const currentTotalWorkedMinutes = Object.values(workedHoursByDate).reduce((sum, hours) => sum + hours, 0) * 60;
    const currentAverageEffectifDirect = calculateAverageEffectifDirectValue();
    const currentMinuteProduit = await calculateMinuteProduitValue(selectedModel, selectedChain);
    
    const minutePresanceValue = currentTotalWorkedMinutes * currentAverageEffectifDirect;
    const rendementValue = minutePresanceValue > 0 ? currentMinuteProduit / minutePresanceValue : 0;
    
    // Calculate coute minute = (Coût de Revient Total + IS) / (Rendement * Moyenne Effectif Direct * Total Heures Travaillées)
    const denominator = rendementValue * currentAverageEffectifDirect * currentTotalWorkedMinutes; // Convert minutes back to hours
    const couteMinuteValue = denominator > 0 ? (totalCoûtDeRevient + IS) / denominator : 0;
    
    setMinutePresance(minutePresanceValue);
    setRendement(rendementValue);
    setCouteMinute(couteMinuteValue);
    
    console.log('Minute Presance Calculation (Direct):');
    console.log('  - Total Worked Minutes:', currentTotalWorkedMinutes);
    console.log('  - Average Effectif Direct:', currentAverageEffectifDirect);
    console.log('  - Minute Presance (minutes * average effectif):', minutePresanceValue);
    
    console.log('Rendement Calculation (Direct):');
    console.log('  - Minute Produit:', currentMinuteProduit);
    console.log('  - Minute Presance:', minutePresanceValue);
    console.log('  - Rendement (produit / presance):', rendementValue);
    
    console.log('Coute Minute Calculation (Direct):');
    console.log('  - Coût de Revient Total:', totalCoûtDeRevient);
    console.log('  - IS:', IS);
    console.log('  - Rendement:', rendementValue);
    console.log('  - Average Effectif Direct:', currentAverageEffectifDirect);
    console.log('  - Total Heures Travaillées:', currentTotalWorkedMinutes / 60);
    console.log('  - Denominator (rendement * effectif * heures):', denominator);
    console.log('  - Coute Minute ((coût + IS) / denominator):', couteMinuteValue);
    
    // Set the state values
    setTotalCoûtDeRevient(totalCoûtDeRevient);
    setMargeNette(margeNette);
    setIS(IS);
    
    console.log("🔍 === END PRICE PER MINUTE CALCULATION DEBUG ===");
  };

  // Handle chain selection
  const handleChainChange = async (e) => {
    const chainId = e.target.value;
    setSelectedChain(chainId);
    
    if (chainId) {
      const modelResponse = await api.get(`/getmodelsByChain/${chainId}`);
      const modelId = modelResponse.data.id;
      setSelectedModel(modelId);
      
      // Fetch all required data
      await Promise.all([
        fetchWorkedHours(chainId),
        fetchEffectiveDataByDate(chainId),
        fetchEffectiveIndirectDataByDate(chainId),
        fetchCle(chainId),
        fetchChainData(modelId, chainId),
        fetchTempAlloue(modelId)
      ]);
    } else {
      setSelectedModel("");
      setWorkedHoursByDate({});
      setEffectiveDataByDate({});
      setEffectiveIndirectDataByDate({});
      setCle(0);
      setFilsParChain(0);
      setTotalCoûtDeRevient(0);
      setProductionChainValeur(0);
      setMargeNette(0);
      setIS(0);
      setValeurDeTravail(0);
      setAverageEffectifDirect(0);
      setTotalWorkedMinutes(0);
      setMinuteProduit(0);
      setMinutePresance(0);
      setRendement(0);
      setCouteMinute(0);
    }
  };

  // Fetch system constants and chains on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const systemResponse = await api.get("/system_constants_latest");
        if (systemResponse.data) {
          const { id, created_at, updated_at, effectif_fix, ...filteredData } = systemResponse.data;
          setSystemConstant(filteredData);
        }
        fetchChains();
    } catch (error) {
        console.error("Error fetching data:", error);
    }
  };

    fetchData();
  }, []);

  // Calculate total coût de revient when all required data is available
  useEffect(() => {
    if (
      Object.keys(workedHoursByDate).length > 0 &&
      Object.keys(effectiveDataByDate).length > 0 &&
      Object.keys(effectiveIndirectDataByDate).length > 0 &&
      cle > 0 &&
      filsParChain > 0 &&
      productionChainValeur > 0 &&
      systemConstant.Nombre_d_heures_par_jour
    ) {
      calculateDayByDayCoûtDeRevient();
    }
  }, [workedHoursByDate, effectiveDataByDate, effectiveIndirectDataByDate, cle, filsParChain, productionChainValeur, systemConstant]);

  return (
    <div className="ml-7 mt-5">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold">Coût Minute et taux de rendement réels</h2>
            <div className="ml-7 mb-4 pr-6">
              <select
                className="block w-full mt-4 outline-0 p-[.5rem] border border-[#b3b3b3] focus:border-2 focus:border-[#2684ff] rounded"
                value={selectedChain}
            onChange={handleChainChange}
              >
            <option value="">Choisir une chaîne</option>
                {chains.map((chain) => (
                  <option key={chain.id} value={chain.id}>
                    {chain.name}
                  </option>
                ))}
              </select>
            </div>
      </div>
      
      <div className="w-full mr-5">
        {error ? (
          <div className="text-red-500 ml-7">{error}</div>
        ) : (
          <div className="mt-4">
            {selectedChain && totalCoûtDeRevient > 0 ? (
              <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6">
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Rendement</h3>
                    <p className="text-2xl font-bold text-pink-600">
                      {(rendement * 100).toFixed(2)}%
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Coute Minute</h3>
                    <p className="text-2xl font-bold text-red-600">
                      {couteMinute.toFixed(2)} DH
                    </p>
                  </div>
                </div>
                
              </div>
            ) : (
              <div className="text-center py-8 text-gray-500">
                <p>Aucune donnée disponible. Veuillez sélectionner une chaîne pour voir les calculs.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PricePerMinute;
